<div class="alerts-section-header">Events</div>

<p>Filter Events by Score</p>

<mat-form-field appearance="outline">
  <mat-label>Name</mat-label>
  <mat-select
    #selectorEventsScore
    [(ngModel)]="currentAlert.score_type"
    (selectionChange)="onEventsScoreChange($event)"
    required
  >
    <mat-option *ngFor="let score of scoreEventsTypes" [value]="score.value">{{
      score.label
    }}</mat-option>
  </mat-select>
</mat-form-field>

<ng-container *ngIf="currentAlert.score_type">
  <p>Add/Modify {{ showEventsFilterLabel() }} Events</p>

  <mat-form-field floatLabel="never" appearance="outline" class="field-type">
    <mat-label>
      <mat-icon>search</mat-icon>
      Click to scroll or type... *
    </mat-label>
    <input
      #inputEvents
      type="text"
      placeholder="Select Events"
      aria-label="Select Events"
      matInput
      [matAutocomplete]="auto"
      [formControl]="eventsControl"
    />
  </mat-form-field>

  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFnEvents"
    (opened)="onAutocompleteOpen()"
    (closed)="onAutocompleteClose()"
  >
    <div class="autocomplete-list">
      <mat-optgroup
        *ngFor="
          let group of filteredEventCategories
            | async
            | orderBy: 'name'
            | filterBy: ['id'] : scoreCategories : strictFiltering
        "
      >
        <div>
          <mat-checkbox
            [checked]="group.selected"
            (change)="toggleEventGroupSelection(group, filteredEvents)"
            (click)="$event.stopPropagation()"
          >
            {{ group.name }}
          </mat-checkbox>
        </div>

        <mat-option
          *ngFor="
            let event of filteredEvents
              | async
              | orderBy: 'name'
              | filterBy: ['category'] : group.name
              | filterBy: ['id'] : scoreEvents : strictFiltering
          "
          [value]="selectedEvents"
          class="score-event-option"
        >
          <div>
            <mat-checkbox
              [checked]="event.selected"
              (change)="toggleEventSelection(event); unselectGroup(group)"
              (click)="$event.stopPropagation()"
            >
              {{ event.name }}
            </mat-checkbox>
          </div>
        </mat-option>
      </mat-optgroup>
    </div>

    <div class="autocomplete-footer">
      <button mat-button (click)="clearEvents()">CLEAR</button>
      <button
        mat-button
        [class.button-active]="this.selectedEvents.length"
        (click)="selectEvents()"
      >
        SELECT
        {{
          selectedEvents && selectedEvents.length > 0
            ? selectedEvents.length
            : ''
        }}
      </button>
    </div>
  </mat-autocomplete>

  <p>Selected Events</p>

  <mat-chip-list #chipList>
    <mat-chip
      *ngFor="let event of selectedEvents"
      selectable="true"
      removable="true"
      (removed)="removeEvent(event)"
    >
      {{ event.name }}
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
  </mat-chip-list>

  <p>Set Impact Level</p>

  <div
    class="alerts-events-impact"
    appDetectVisibility
    (isVisible)="markFieldAsSeen($event)"
  >
    <div>
      <p>Low Impact Events</p>
      <p>(more alerts)</p>
    </div>
    <mat-slider
      *ngIf="userInfo.isAdmin"
      [(ngModel)]="currentAlert.threshold"
      (input)="currentAlert.threshold = $event.value"
      min="0"
      max="5"
      step="1"
      [displayWith]="sliderLabel"
    ></mat-slider>
    <mat-slider
      *ngIf="!userInfo.isAdmin"
      [(ngModel)]="currentAlert.threshold"
      (input)="currentAlert.threshold = $event.value"
      min="1"
      max="5"
      step="1"
      [displayWith]="sliderLabel"
    ></mat-slider>
    <div>
      <p>High Impact Events</p>
      <p>(less alerts)</p>
    </div>
  </div>
</ng-container>
